export default "__VITE_ASSET__CsGuOtjY__"